<bn-loading-overlay></bn-loading-overlay>
<div class="mb-3 row">
  <div class="col">
    <h5>{{ ehFGBS ? 'Limite de contratação' : 'Limite da cesta atual' }}
      <span *ngIf="dataLimitePesquisa" class="letra-miuda">&nbsp;&nbsp;&nbsp;atualizado em: {{ dataLimitePesquisa
        }}</span>
    </h5>
  </div>
  <div class="col-auto" *ngIf="podeCadastrarLimiteFundo">
    <button class="btn btn-primary" type="button" [routerLink]="['/limite-fundo/cadastro']"
      ngbTooltip="Cadastrar ou atualizar limite total de contratação para a cesta corrente do fundo"><i
        class="fa fa-file-signature">
      </i> {{ ehFGBS ? 'Cadastrar/editar limite de contratação' : 'Cadastrar/editar limite da cesta' }}</button>
    <button class="btn btn-primary" type="button" [routerLink]="['/limite-historico/listagem']"
      ngbTooltip="Histórico correspondente à cesta corrente do fundo" placement="top-right"><i class="fa fa-clock">
      </i> Histórico</button>
  </div>
</div>

<ng-container *ngIf="modalidade">
  <div class="row">
    <div class="table-responsive" *ngIf="limitesFundo else semLimite">
      <table class="table">
        <thead>
          <tr>
            <th>Limite</th>
            <th *ngIf="!ehFGBS">Cesta</th>
            <th *ngIf="!ehFGBS" class="text-end">Data de referência</th>
            <th class="titulo-moeda">Valor limite total <span *ngIf="modalidade.textoObservacaoLimiteTotal">*</span>
            </th>
            <th class="titulo-moeda">Valor utilizado</th>
            <th *ngIf="ehFGE" class="titulo-moeda">Valor cedido pgto ECG
              <a href="javascript:void(0)"  (click)="abrirModalListagem('Modal com body sendo uma template', 'lg', true, true);">
                <i class="fas fa-external-link-alt cursor-pointer margin-left-5" placement="left-top"
                  ngbTooltip="Exibe lista dos valores cedidos para pgto por ECG"></i></a>
            </th>
            <th class="titulo-moeda">Valor disponível</th>
            <th *ngIf="modalidade.sigla == 'FGI PEAC'" class="text-center">Limite especial (art. 16-A)</th>
          <tr>
        </thead>
        <tbody>
          <tr *ngIf="limitesFundo?.global">
            <td [ngClass]="( limitesFundo?.especial?.ativo ? 'fundo-destaque' : '')">
              Global
            </td>
            <td *ngIf="!ehFGBS">
              {{ limitesFundo?.numeroTranche }}
            </td>
            <td *ngIf="!ehFGBS" [ngClass]="'moeda ' + ( limitesFundo?.especial?.ativo ? 'fundo-destaque' : '')">
              {{ dataReferenciaLimiteFundo | date: 'dd/MM/yyyy' }}
            </td>
            <td [ngClass]="'moeda ' + ( limitesFundo?.especial?.ativo ? 'fundo-destaque' : '')">
              {{ limitesFundo?.global.valorLimiteTotal | bnMask:'MOEDA' }}
            </td>
            <td [ngClass]="'moeda ' + ( limitesFundo?.especial?.ativo ? 'fundo-destaque' : '')">
              {{ limitesFundo?.global.valorLimiteUtilizado | bnMask:'MOEDA' }}
            </td>
            <td *ngIf="ehFGE" [ngClass]="'moeda ' + ( limitesFundo?.especial?.ativo ? 'fundo-destaque' : '')">
              {{ limitesFundo?.global.valorCedidoPgtoEcg | bnMask:'MOEDA' }}
            </td>
            <td [ngClass]="'moeda ' + ( limitesFundo?.especial?.ativo ? 'fundo-destaque' : '')">
              {{ limitesFundo?.global.valorLimiteDisponivel | bnMask:'MOEDA' }}
            </td>
            <td *ngIf="modalidade.sigla == 'FGI PEAC'"
              [ngClass]="'text-center ' + ( limitesFundo?.especial?.ativo ? 'fundo-destaque' : '')">
              {{ limitesFundo?.especial?.ativo ? 'Ativado' : 'Desativado' }}
            </td>
          </tr>
          <tr *ngFor="let limiteAdicional of limitesFundo?.limitesAdicionais">
            <td>
              {{ limiteAdicional.nome }}
            </td>

            <td *ngIf="!ehFGBS">
              {{ limitesFundo?.numeroTranche }}
            </td>

            <td *ngIf="!ehFGBS" class="moeda">
              {{ limiteAdicional.dataInicioValidade | date: 'dd/MM/yyyy' }}
            </td>

            <td class="moeda">
              {{ limiteAdicional.valorLimite.valorLimiteTotal | bnMask:'MOEDA' }}
            </td>

            <td class="moeda">
              {{ limiteAdicional.valorLimite.valorLimiteUtilizado | bnMask:'MOEDA' }}
            </td>

            <td *ngIf="ehFGE" class="moeda">
              {{ limiteAdicional.valorLimite.valorCedidoPgtoEcg | bnMask:'MOEDA' }}
            </td>

            <td class="moeda">
              {{ limiteAdicional.valorLimite.valorLimiteDisponivel | bnMask:'MOEDA' }}
            </td>

            <td *ngIf="modalidade.sigla == 'FGI PEAC'" class="text-center">
              N/A
            </td>
          </tr>
          <tr *ngIf="limitesFundo?.grandesEmpresas">
            <td>
              Grandes Empresas
            </td>
            <td class="moeda">
              {{ limitesFundo?.grandesEmpresas.valorLimiteTotal | bnMask:'MOEDA' }}
            </td>
            <td class="moeda">
              {{ limitesFundo?.grandesEmpresas.valorLimiteUtilizado | bnMask:'MOEDA' }}
            </td>
            <td class="moeda">
              {{ limitesFundo?.grandesEmpresas.valorLimiteDisponivel | bnMask:'MOEDA' }}
            </td>
            <td class="text-center">
              N/A
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="modalidade.textoObservacaoLimiteTotal" class="letra-miuda">
    <p>* {{modalidade.textoObservacaoLimiteTotal}}
    </p>
  </div>
</ng-container>

<br>

<div class="col-auto" *ngIf="podeCadastrarLimiteFundo && limitesFundoTranchesPassadas?.length">

  <div class="bn-form-group row">
    <div class="col">
      <h5>Limites das cestas passadas</h5>
    </div>
  </div>

  <ng-container *ngIf="modalidade">
    <div class="row">
      <div class="table-responsive" *ngIf="limitesFundo else semLimite">
        <table class="table">
          <thead>
            <tr>
              <th>Limite</th>
              <th>Cesta</th>
              <th class="titulo-moeda">Valor limite total</th>
              <th class="titulo-moeda">Valor utilizado</th>
              <th class="titulo-moeda">Valor disponível</th>
              <th *ngIf="modalidade.sigla == 'FGI PEAC'" class="text-center">Limite especial (art. 16-A)</th>
            <tr>
          </thead>
          <tbody>
            <tr *ngFor="let limiteTranchePassada of limitesFundoTranchesPassadas">
              <td [ngClass]="( limitesFundoTranchesPassadas?.especial?.ativo ? 'fundo-destaque' : '')">
                Global
              </td>
              <td>
                {{ limiteTranchePassada?.numeroTranche }}
              </td>
              <td [ngClass]="'moeda ' + ( limitesFundoTranchesPassadas?.especial?.ativo ? 'fundo-destaque' : '')">
                {{ limiteTranchePassada?.global.valorLimiteTotal | bnMask:'MOEDA' }}
              </td>
              <td [ngClass]="'moeda ' + ( limitesFundoTranchesPassadas?.especial?.ativo ? 'fundo-destaque' : '')">
                {{ limiteTranchePassada?.global.valorLimiteUtilizado | bnMask:'MOEDA' }}
              </td>
              <td [ngClass]="'moeda ' + ( limitesFundoTranchesPassadas?.especial?.ativo ? 'fundo-destaque' : '')">
                {{ limiteTranchePassada?.global.valorLimiteDisponivel | bnMask:'MOEDA' }}
              </td>
              <td *ngIf="modalidade.sigla == 'FGI PEAC'"
                [ngClass]="'text-center ' + ( limitesFundoTranchesPassadas?.especial?.ativo ? 'fundo-destaque' : '')">
                {{ limiteTranchePassada?.especial?.ativo ? 'Ativado' : 'Desativado' }}
              </td>
            </tr>
            <tr *ngIf="limiteTranchePassada?.grandesEmpresas">
              <td>
                Grandes Empresas
              </td>
              <td class="moeda">
                {{ limiteTranchePassada?.grandesEmpresas.valorLimiteTotal | bnMask:'MOEDA' }}
              </td>
              <td class="moeda">
                {{ limiteTranchePassada?.grandesEmpresas.valorLimiteUtilizado | bnMask:'MOEDA' }}
              </td>
              <td class="moeda">
                {{ limiteTranchePassada?.grandesEmpresas.valorLimiteDisponivel | bnMask:'MOEDA' }}
              </td>
              <td class="text-center">
                N/A
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>

<br>


<h5>Limite por agente financeiro</h5>

<div class="container">
  <form class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class=" row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>

      <div class="col-auto" *ngIf="podeCadastrarLimiteAgente">
        <button class="btn btn-primary" type="button" [routerLink]="['/limite/cadastro']"
          ngbTooltip="Tela para cadastro de limites por agente financeiro. Este cadastro é necessário para que o agente financeiro seja habilitado"><i
            class="fa fa-file-signature">
          </i> Cadastrar novo limite de Agente Financeiro</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success align-self-end" (keydown.enter)="buscar()"
          (click)="buscar()" [disabled]="!ideTranche">Pesquisar</button>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="mb-3" [ngClass]="ehFGBS ? 'col-md-12' : 'col-md-4'">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select *ngIf="podeEscolherAgente" (change)="atribuiAgenteFinanceiro($event.target.value)" id="agenteFinanceiro"
          class="form-control">
          <option [value]="-1" selected>Todos</option>
          <option *ngFor="let agente of agentesFinanceiros" [value]="agente.cnpj">{{ agente.nome + ' (' + agente.cnpj +
            ')' }}</option>
        </select>
        <select *ngIf="!podeEscolherAgente" disabled (change)="atribuiAgenteFinanceiro($event.target.value)"
          id="agenteFinanceiro" class="form-control">
          <ng-container *ngFor="let agente of agentesFinanceiros">
            <option selected *ngIf="agente.cnpj == cnpjUsuario" [value]="agente.cnpj">{{ agente.nome + ' (' +
              agente.cnpj + ')' }}</option>
          </ng-container>
        </select>
      </div>
      <div *ngIf="!ehFGBS" class="bn-form-group col-md-4">
        <label class="form-label" for="tranche">Cesta:</label>
        <select (change)="atribuiTranche($event.target.value)" id="tranche" class="form-select">
          <option value=""></option>
          <option *ngFor="let tranche of tranches" [value]="tranche.id">{{tranche.numeroTranche}}
            ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
        </select>
      </div>
      <div *ngIf="!ehFGBS" class="bn-form-group col-md-4">
        <label class="form-label" for="limite">Limite:</label>

        <select
          (change)="atribuiLimite($event.target.value)"
          id="limite"
          class="form-select"
          [disabled]="!ideTranche">

          <option value="">Global</option>

          <option
            *ngFor="let opcao of limitesAdicionaisOpcoes"
            [value]="opcao.id">

            {{ opcao.descricao }}

          </option>
        </select>
      </div>
    </div>
  </form>
</div>

<ng-template #semLimite>
  <div class="col">
    <p>Não há limite cadastrado para esta modalidade.</p>
  </div>
</ng-template>
<app-limite-listagem [agenteFinanceiro]="agenteFinanceiroPesquisa" [refresh]="refresh"
  [permiteEdicao]="podeCadastrarLimiteAgente" [permiteDetalhe]="podeEscolherAgente && podePesquisarAgente"
  [existeLimiteAgenteFinanceiroTranche]="modalidade.existeLimiteAgenteFinanceiroTranche" [tranche]="trancheSelecionada"
  [ehFGBS]="ehFGBS"
  [idLimiteAdicional]="ideLimiteAdicionalSelecionado">
</app-limite-listagem>


<ng-template #bodyListagemValorTipoPagamentoECG>

  <div class="table-responsive" *ngIf="limitesFundo?.listaLimitePagamentoEcgTerceiroDTO">
    <table class="table">
      <thead>
        <tr>
          <th>Em utilização por</th>
          <th>Valor limite total</th>
        <tr>
      </thead>
      <tbody>
        <tr *ngFor="let limite of limitesFundo?.listaLimitePagamentoEcgTerceiroDTO">
          <td>
            {{ limite?.nomeModalidade }}
          </td>
          <td>
            {{ limite?.valorLimiteTotal | bnMask:'MOEDA' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>